export default {"src":"/_next/static/image/public/images/flags/flag_98.462a426d463b0b566a917444606d4078.svg","height":16,"width":24};